module.exports = __webpack_public_path__ + "img/image80.84d9af17.png";